import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import 'fontsource-roboto'
import CssBaseline from '@material-ui/core/CssBaseline'
import App from './app'
import { AppProviders } from './context'

ReactDOM.render(
  <React.StrictMode>
    <CssBaseline />
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
  document.getElementById('root')
)
